//export const API = "http://api.myownfp.ca:3100";

import { isDev } from "../Components/Environment";


// export const API = "https://api-finplan.myownfp.ca" + isDev() ? ":3101" : "";
// export const APP = "https://app-finplan.myownfp.ca" + isDev() ? ":3001" : "";;


// export const API = "https://api-finplan.myownfp.ca:3101"
// export const APP = "https://app-finplan.myownfp.ca:3001";

function APII() {
    if (isDev()) {
        return "https://api.myownfp.ca:3101";
    }
    return "https://api-finplan.myownfp.ca";
}

function APIM() {
    if (isDev()) {
        return "https://api.myownfp.ca:3103";
    }
    return "https://api-finplan.myownfp.ca";
}

// unused but for completeness
export function APPP() {
    if (isDev()) {
        return "https://app.myownfp.ca:3001";
    }
    return "https://app-finplan.myownfp.ca"
}

export const APIs_Sweep = "/sweep";
export const API_SweepPost = APII() + APIs_Sweep;

export const APIs_SweepData = "/sweep/";

//export const API_goalPost = APII() + "/scenario";
//export const API_goalData = APII() + "/scenario/";

//export const API_chart = APII() + "/chart/";

export const API_login = APII() + "/token/login";

export const API_tokenSignInGoogle = APII() + "/token/signin/google";
export const API_tokenSignInLocal = APII() + "/token/signin/local";
export const API_tokenSignInFacebook = APII() + "/token/signin/facebook";
export const API_tokenSignOut = APII() + "/token/signout";
export const API_tokenRefresh = APII() + "/token/refresh";

export const APIs_selectClient = "/clients";
export const API_selectSubscriber = APII() + "/subscriberSelect";
export const APIs_selectScenario = "/scenarios";
export const APIs_setupAccounts = "/setupAccounts";
export const APIs_setupSavingRules = "/setupSavingRules";
export const APIs_pdflayout = "/pdflayout";
export const APIs_simpleTax = "/simpleTax";


//export const APIs_setupIncomeRules = "/setupIncomeRules";
//export const APIs_setupIncomeRules = "/setupSavingRules";

export const APIs_GetScenarioInputs = "/getScenarioInput";
export const APIs_GetSweepInputs = "/getSweepInput";

export const APIs_Scenario = "/scenario";

//export const API_GetChartInputs = APII() + "/getChartInput/";

export const API_Client = APII() + "/client/";
export const API_ClientClone = APII() + "/client/";
export const API_stripe = APII() + "/stripe";
export const API_ClientQ = APII() + "/clientquick";

// export const API_Client = APII() + "/client/%d/clone";
// export const API_Client = APII() + "/client/%d/account/%s";
// export const API_Client = APII() + "/client/%d/db/%s";
// export const API_Client = APII() + "/client/%d/oas";
// export const API_Client = APII() + "/client/%d/cpp";
// export const API_Client = APII() + "/client/%d/savingrule/%s/%d";
// export const API_Client = APII() + "/client/%d/additionalincome/%d";

export const API_Subscriber = APII() + "/subscriber";
export const APIs_profile = "/profile";
export const APIs_data = "/data";


export const API_WebAnalytics = APII() + "/analytics/web";


export const API_Suggestion = APIM() + "/suggestion"

//
// redirects
//

export const APP_onSignOn = "/clientSelect";
export const APP_onSignUp = "/clientSelect"; // this probably should be be profile first?
export const APP_ScenarioCharts = "/scenarioCharts";
export const APP_setupAccounts = "/setupAccounts";
export const APP_help = "/help";
export const APP_profile = "/profile"
